export const ERRORS = {
  UNAUTHORIZED: "Unauthorized",
};
export const BONDING_CURVE_PROGRESS = 2;
